import { Box, FormControl, Grid, InputLabel, OutlinedInput, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

const Cell = styled(TableCell)({
    padding: '10px',
    fontWeight: 'bold',
});

const DisplaySelection = ({
    displayArr,
    setDisplayArr,
}) => {
    return (
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ padding: '10px' }}>
            <Typography style={{ fontWeight: 'bold' }}>Selection</Typography>
            <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                <TableContainer>
                    <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                        <TableHead>
                            <TableRow>
                                <Cell>Quantity</Cell>
                                <Cell>Category</Cell>
                                <Cell>Sub Category</Cell>
                                <Cell>Manufacturer</Cell>
                                <Cell>Model</Cell>
                                <Cell>Numeric ID</Cell>
                                <Cell>Alphanumeric ID</Cell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayArr.map((a) => (
                                <TableRow>
                                    <TableCell>
                                        <FormControl size="small" fullWidth variant="outlined">
                                            <InputLabel htmlFor="standard-adornment-password">Quantity</InputLabel>
                                            <OutlinedInput
                                                label="Quantity"
                                                type='number'
                                                value={a?.quantity || null}
                                                onChange={(e) => {
                                                    setDisplayArr((prevData) => {
                                                        return prevData.map((item) =>
                                                            item.item_id === a.item_id
                                                                ? { ...item, quantity: Number(e.target.value) }
                                                                : item
                                                        );
                                                    });
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        {a?.category}
                                    </TableCell>
                                    <TableCell>
                                        {a?.subCategory}
                                    </TableCell>
                                    <TableCell>
                                        {a?.manufacturer}
                                    </TableCell>
                                    <TableCell>
                                        {a?.model}
                                    </TableCell>
                                    <TableCell>
                                        {a?.numericId}
                                    </TableCell>
                                    <TableCell>
                                        {a?.alphaNumericId}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Grid>
    )
}

export default DisplaySelection;